export const RMA_ACTIVATION_RESULT = {
  SUCCESS: 'SUCCESS',
  ALREADY_ACTIVE: 'ALREADY_ACTIVE',
  FAILURE: 'FAILURE',
} as const;

export type RmaActivationResult =
  (typeof RMA_ACTIVATION_RESULT)[keyof typeof RMA_ACTIVATION_RESULT];
